import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { RegisterInventoryClassComponent } from '../register-inventory-class/register-inventory-class.component';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { InventoryClassTableModel } from 'src/app/models/tables/inventory/inventory-class-table.model';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { InventoryClassModel } from 'src/app/models/inventory/inventory-class.model';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { UserModel } from 'src/app/models/authentication/user.model';
import { InventoryClassService } from 'src/app/services/inventory/inventory-class.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import Swal from 'sweetalert2';
import { WindowEnums } from 'src/app/enum/window-enums';

@Component({
  selector: 'app-inventory-class',
  templateUrl: './inventory-class.component.html',
  styleUrls: ['./inventory-class.component.scss'],
  standalone: false
})
export class InventoryClassComponent implements OnInit {
  @ViewChild('inventoryClassModal') inventoryClassModalComponent?: CustomModalComponent | null = null;
  componentRegisterInventoryClass = RegisterInventoryClassComponent;
  ascendant: boolean = true;
  columnSort: string | null = null;
  filters: ColumnResponseModel[] = [];
  data: PagedResponseModel<InventoryClassTableModel> = new PagedResponseModel<InventoryClassTableModel>();
  header: ColumnResponseModel[] = [];
  isOpened: string | undefined = undefined;
  inputsForInventoryClass$ = new BehaviorSubject<any>({
    inventoryClassModel: new InventoryClassModel,
  });
  limit: number = 10;
  nameWindow: string = 'Clases de Inventario';
  outputForInventoryClassModals$ = new Subject<any>();
  page: number = 1;
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  projectName = ProjectName.projectName;
  subscription: Subscription;
  tableActions: TableAction[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      action: 'edit'
    },
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      action: 'delete'
    },
  ];
  url: string = "inventory-class";
  userAuthenticated: UserModel = new UserModel();

  constructor(private inventoryClassService: InventoryClassService,
    private headerService: HeaderService,
    private optionWindowService: OptionWindowService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) { }

  async ngOnInit() {
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    const filters = localStorage.getItem(this.url);
    if (filters) this.filters = JSON.parse(filters);
    this.headerService.setTitle(this.nameWindow);
    await Promise.all([
      this.getColumnsForConsultation(),
      this.getInventoryClassesForConsultation(),
    ]);
    this.getPermission();
    this.subscription = this.inputsForInventoryClass$.subscribe(async ({ type }) => {
      switch (type) {
        case 'reload':
          await this.getInventoryClassesForConsultation();
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  async deleteInventoryClass(inventoryClass: InventoryClassTableModel) {
    const result = await Swal.fire({
      title: 'Atención',
      text: `¿Realmente desea eliminar la clase de inventario "${inventoryClass.name}"?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    });
    if (result.isConfirmed) {
      try {
        await firstValueFrom(this.inventoryClassService.deleteInventoryClass(inventoryClass.inventoryClassId));
        this.toastHandlerService.showToast(
          'success',
          'La clase de inventario fue eliminado exitosamente.'
        );
        this.getInventoryClassesForConsultation();
      } catch (error) {
        console.error('Error al eliminar la clase de inventario.', error);
      }
    }
  }

  async getColumnsForConsultation() {
    try {
      if (this.header.length === 0) {
        this.header = await firstValueFrom(this.inventoryClassService.getColumnsForConsultation());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  async getInventoryClassesForConsultation() {
    try {
      this.data = await firstValueFrom(this.inventoryClassService.getInventoryClassesForConsultation(
        this.page, this.limit, this.columnSort, this.ascendant, this.filters
      ));
    } catch (error) {
      console.error('Error al buscar las clases de inventarios.', error);
    }
  }

  async getPermission() {
    let url = this.router.url as string
    url = url.substring(1);
    this.url = url;
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos por clase de inventario.', error);
    }
    this.getPermissionsForUserByWindow();
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
    this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.InventoryClass));
  }

  openModalInventoryClass() {
    if (!this.validations()) return;

    this.updateInput(new InventoryClassModel);
  }

  onAction(event: { action: string, item?: InventoryClassTableModel, selectedItems?: number[] }) {
    if (!this.validations()) return;

    if (event.action === 'edit' && event.item) {
      const inventoryClassModel = new InventoryClassModel;
      inventoryClassModel.inventoryClassId = event.item.id;
      inventoryClassModel.code = event.item.code;
      inventoryClassModel.name = event.item.name;
      this.updateInput(inventoryClassModel)
    }
    if (event.action === 'delete' && event.item) {
      this.deleteInventoryClass(event.item);
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filters = this.removeDuplicates(filters);
    this.filters.forEach((filter: any) => this.processFilter(filter));
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    await this.getInventoryClassesForConsultation();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  reloadList(reload: boolean) {
    if (reload) {
      this.getInventoryClassesForConsultation();
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  updateInput(inventoryClassContract: InventoryClassModel) {
    this.inputsForInventoryClass$.next({
      inventoryClassModel: inventoryClassContract,
    });
    this.inventoryClassModalComponent && this.inventoryClassModalComponent.show();
  }

  validations() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para modificar las clases de inventario. Comuníquese con el administrador del sistema', 'Atención');
      return false;
    }

    return true;
  }

}
